export const Platforma = require('./Wspolprace/platforma-logo.png');
export const M3n = require('./Wspolprace/3mn-logo.png');
export const Ang = require('./Wspolprace/ang-logo.png');
export const Oaza = require('./Wspolprace/oaza.png');